import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-29aeb05c")
const _hoisted_1 = {
  key: 0,
  class: "_history"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", null, "Continue playing", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_GamePreview = _resolveComponent("GamePreview")!

  return (_ctx.historyFields && _ctx.historyFields.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_IconButton, {
            icon: "cross",
            clear: true,
            onClick: _ctx.closeHistory
          }, null, 8, ["onClick"])
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.historyFields, (game, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (!game.finished && !game.stopped)
              ? (_openBlock(), _createElementBlock("div", {
                  class: "row",
                  key: `game_${index}`
                }, [
                  _createVNode(_component_GamePreview, {
                    history: true,
                    game: game,
                    onClick: ($event: any) => (_ctx.$router.push({path:`/app/lobby/${game.meta.gameId}/${game.meta.code}`}))
                  }, null, 8, ["game", "onClick"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 256))
      ]))
    : _createCommentVNode("", true)
}